import {Injectable} from "@angular/core";
import {firstValueFrom} from "rxjs";
import {IFeatureFlag} from "../models/featureFlag";
import {FeatureFlagDataService} from "./featureFlag-data.service";

@Injectable({
    providedIn: 'root'
})
export class FeatureFlagService {

    private _featureFlags: IFeatureFlag[] = [];
    private _initialized = false;

    constructor(private featureFlagDataService: FeatureFlagDataService) { }

    featureOff(featureCode: string) {
        return !this.featureOn(featureCode);
    }

    featureOn(featureCode: string) {
        if (!featureCode) {
            return true;
        }

        return this._featureFlags.some(feature => feature.featureCode.toLowerCase() === featureCode.toLowerCase());
    }

    get initialized() {
        return this._initialized;
    }

    public async initialize(): Promise<void> {
        this._featureFlags = await firstValueFrom(this.featureFlagDataService.getFeatureFlags());
        this._initialized = true;
    }
}